import { useAction } from '@src/redux/hooks/useAction';
import { useSelect } from '@src/redux/hooks/useSelect';
import { useAsync } from '@src/redux/hooks/useAsync';

import {
  GET_CLAIM,
  VERIFY_PAYMENT_INFO,
  SET_MAIN_RADIO_GROUP,
  SET_IS_PROCEDURE_CODE,
  RESET_STATE,
  VERIFY_COMPANY_NAME,
  VALIDATE_CODE,
  // SET_US_MAIL_SECURITY_GROUP,
  TIN_ADDRESS_API,
  GENERATE_SECURITY_KEY,
  SET_INFO_ERROR,
} from './constants';
import {
  getClaim,
  verifyPaymentInfo,
  setMainRadioGroup,
  setReduxIsProcedureCode,
  resetState,
  verifyCompanyName,
  validateCode,
  setUSMailSecurityRadioGroup,
  tinAddressApi,
  generateSecurityKey,
  setValidationErrorType,
} from './actions';

const verifyClaimSelector = (state) => {
  return state.verifyClaim;
};

export const useVerifyClaim = {
  state: () => {
    return useSelect(verifyClaimSelector);
  },
  actions: () => {
    return {
      getClaim: useAction(getClaim, {
        saga: useAsync(GET_CLAIM),
      }),
      verifyPaymentInfo: useAction(verifyPaymentInfo, {
        saga: useAsync(VERIFY_PAYMENT_INFO),
      }),
      setMainRadioGroup: useAction(setMainRadioGroup, {
        saga: useAsync(SET_MAIN_RADIO_GROUP),
      }),
      setValidationErrorType: useAction(setValidationErrorType, {
        saga: useAsync(SET_INFO_ERROR),
      }),
      setUSMailSecurityRadioGroup: useAction(setUSMailSecurityRadioGroup, {
        // saga: useAsync(SET_US_MAIL_SECURITY_GROUP),
      }),
      setReduxIsProcedureCode: useAction(setReduxIsProcedureCode, {
        saga: useAsync(SET_IS_PROCEDURE_CODE),
      }),
      resetState: useAction(resetState, {
        saga: useAsync(RESET_STATE),
      }),
      verifyCompanyName: useAction(verifyCompanyName, {
        saga: useAsync(VERIFY_COMPANY_NAME),
      }),
      validateSecurityKey: useAction(validateCode, {
        saga: useAsync(VALIDATE_CODE),
      }),
      tinAddressApi: useAction(tinAddressApi, {
        saga: useAsync(TIN_ADDRESS_API),
      }),
      generateSecurityKey: useAction(generateSecurityKey, {
        saga: useAsync(GENERATE_SECURITY_KEY),
      }),
    };
  },
};
